/* eslint-disable react/prop-types */
import McqQuestion from "./mcq";
import MCQMultiple from "./mcq_multiple";
import Numeric from "./numeric";
import PassageSingle from "./passage_single";

const QuestionRenderer = ({question,selectedAnswer,currentIndex,onSelect,onClear}) => {
  

  if (!question) return null;

  switch (question.question_type) {
    case "MCQ":
      return (
        <McqQuestion
          question={question}
          selectedAnswer={selectedAnswer}
          currentIndex={currentIndex}
          onSelect={onSelect}
          onClear={onClear}
        />
      );

    case "MCQ_MULTI":
      return (
        <MCQMultiple
          question={question}
          currentIndex={currentIndex}
          selectedAnswer={selectedAnswer || []}
          onSelect={onSelect}
        />
      );

    case "NUMERIC":
      return (
        <Numeric
          question={question}
          currentIndex={currentIndex}
          selectedAnswer={selectedAnswer}
          onSelect={onSelect}
        />
      );

    case "PASSAGE_SINGLE":
      return (
        <PassageSingle
          question={question}
          currentIndex={currentIndex}
          selectedAnswer={selectedAnswer}
          onSelect={onSelect}
        />
      );

      case "PASSAGE_MULTI":
        return (
          <PassageSingle
            question={question}
            currentIndex={currentIndex}
            selectedAnswer={selectedAnswer}
            onSelect={onSelect}
          />
        );
  

  

    default:
      return <div>Unsupported question type</div>;
  }
};

export default QuestionRenderer;